export const typographyStyles = {
  MuiTypography: {
    styleOverrides: {
      root: ({ _ownerState, theme }) => ({
        color: theme.palette.primary.main,
      }),
    },
  },
};
